module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_proctor_sm-6f03967bcc917c020b764ee59b1f410d.png";